import Skeleton from '@discover-ui/skeleton';

export default function FilteredRestaurantCarouselCardSkeleton() {
  return (
    <article className="flex w-full flex-col overflow-hidden rounded border border-gray-200 bg-white shadow-sm">
      <Skeleton className="h-[140px] w-full rounded-none" />
      <div className="min-w-0 px-3 py-4">
        <Skeleton className="h-5 w-3/4 rounded" />
        <div className="mt-3 py-xs">
          <Skeleton className="h-5 w-1/2 rounded" />
        </div>
        <Skeleton className="h-6 w-2/5 rounded" />
      </div>
    </article>
  );
}
